import { UpsellBillingTrigger } from "@redotech/cockroachdb-codegen/congodb/upsell-billing-trigger";

/**
 * Decides whether the customer-selected exchange shipping fee will be
 * charged via Stripe at submit time, or rolled into the exchange draft
 * order. Single source of truth for the billing-path decision — exposed as
 * `chargesExchangeShippingViaStripe` on `ReturnTotals` (legacy) and
 * `ReturnSummaryTotals` (new RAC), and reused by both server-side
 * (charge-customer, exchangeInvoice) and client-side (payment-collection)
 * callers.
 *
 * The decision: charge via Stripe when either the team has opted into the
 * legacy always-Stripe behavior (`forceExchangeStripeBilling`), or when
 * the rest of the exchange is on the Stripe path (`upsellBillingTrigger
 * === RETURN_CREATED`). Otherwise the fee rides along on the exchange
 * draft order — and the calculator folds it into
 * `displayCharge`/`outstandingBalance` so display surfaces don't need to
 * add it manually.
 *
 * Takes `forceExchangeStripeBilling` directly (rather than a `team`) so
 * the customer portal can call this without owning a server-side team
 * shape; server callers extract `team.settings.exchanges?.
 * forceExchangeStripeBilling` at the call site.
 */
export function chargesExchangeShippingViaStripe({
  forceExchangeStripeBilling,
  upsellBillingTrigger,
}: {
  forceExchangeStripeBilling?: boolean | null;
  upsellBillingTrigger: UpsellBillingTrigger | null | undefined;
}): boolean {
  return (
    !!forceExchangeStripeBilling ||
    upsellBillingTrigger === UpsellBillingTrigger.ReturnCreated
  );
}
